import { render } from "./NotificationManagerComponent.vue?vue&type=template&id=2abc48e0"
import script from "./NotificationManagerComponent.vue?vue&type=script&lang=js"
export * from "./NotificationManagerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__